import { createApp } from 'vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'animate.css';
import '@/assets/css/index.css'
import CountTo from 'vue3-count-to';
import App from './App.vue';
import router from './router';
import 'vue-fullpage.js/dist/style.css'
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

const app = createApp(App); // 创建应用实例
app.use(router); // 使用路由
app.use(VueFullPage)
app.use(ElementPlus)
app.component('CountTo', CountTo);
app.mount('#app'); // 挂载应用
